import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'results';
export const route = 'results/[searchParams]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/ResultsPage')));